import { getUsers, postUser, putUser } from "../../api/users";
import { createSliceWithThunks } from "../utils";

const initialState = {
  post: {
    data: null,
    status: "idle",
    error: null,
  },
  get: {
    data: null,
    status: "idle",
    error: null,
  },
  put: {
    data: null,
    status: "idle",
    error: null,
  },
};

export const userSlice = createSliceWithThunks({
  name: "userSlice",
  initialState: initialState,
  reducers: (create) => ({
    resetStateUsers: create.reducer((state, { payload }) => {
      if (payload) {
        for (let key in payload) {
          state[`${payload[key]}`] = initialState[`${payload[key]}`];
        }
      } else {
        for (let key in initialState) {
          state[key] = initialState[key];
        }
      }
    }),
    //* thunks
    registerUser: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await postUser(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.post.status = "loading";
        },
        rejected: (state, action) => {
          state.post.status = "failed";
          state.post.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 201 || status === 200) {
            if (data?.type === "success") {
              state.post.data = data?.data;
            } else {
              state.post.error = { message: data?.data || "An error occurred" };
            }
          } else {
            state.post.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.post.status = "idle";
        },
      }
    ),
    fetchUsers: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await getUsers(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.get.status = "loading";
        },
        rejected: (state, action) => {
          state.get.status = "failed";
          state.get.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 200) {
            if (data?.type === "success") {
              state.get.data = data?.data;
            } else {
              state.get.error = { message: data?.data || "An error occurred" };
            }
          } else {
            state.get.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.get.status = "idle";
        },
      }
    ),
    updateUser: create.asyncThunk(
      async (payload, { rejectWithValue }) => {
        try {
          const response = await putUser(payload);
          return response;
        } catch (err) {
          return rejectWithValue(err.message);
        }
      },
      {
        pending: (state) => {
          state.put.status = "loading";
        },
        rejected: (state, action) => {
          state.put.status = "failed";
          state.put.error = action.error;
        },
        fulfilled: (state, { payload }) => {
          const { status, data } = payload;
          if (status === 202 || status === 200) {
            if (data?.type === "success") {
              state.put.data = data?.data;
            } else {
              state.put.error = { message: data?.data || "An error occurred" };
            }
          } else {
            state.put.error = {
              message: data?.data || data?.message || "An error occurred",
            };
          }
          state.put.status = "idle";
        },
      }
    ),
  }),
});

export const { resetStateUsers, fetchUsers, updateUser, registerUser } =
  userSlice.actions;
export default userSlice.reducer;
